import { createAction, props } from '@ngrx/store';

import { TenantSettingsResponse } from '@core/api/tenant/tenant.models';
import { ThemePreference, UserPreferences } from '@core/api/user-preferences/user-preferences.models';

import { PermissionStoreModelEnum } from '@domain/permissions/permissions.enums';
import { ThemeStoreModel } from '@domain/theme/theme.models';

interface ImpersonationActionPayload {
  token: string;
  targetUserId: string;
  permissions: PermissionStoreModelEnum[];
  name?: string;
  organisationId?: string;
  navigateHome?: boolean;
}

export const setInitialTokenAndPermissions = createAction(
  '[Auth] set initial token and permissions',
  props<{
    token: string | null;
    refreshTokenExpiresTimestamp: string | null;
    permissions?: PermissionStoreModelEnum[];
    name?: string;
    organisationId?: string;
    impersonation?: ImpersonationActionPayload;
  }>()
);
export const startImpersonation = createAction('[Auth] start impersonation', props<{ targetUserId: string }>());
export const renewImpersonation = createAction('[Auth] renew impersonation');
export const impersonationSuccess = createAction('[Auth] impersonation success', props<ImpersonationActionPayload>());
export const impersonationFailure = createAction('[Auth] impersonation failure', props<{ error: string }>());
export const exitImpersonation = createAction('[Auth] exit impersonation');
export const activeUserChanged = createAction('[Auth] active user changed');
export const setUpdatedTokenAndPermissions = createAction(
  '[Auth] set updated token and permissions',
  props<{
    token: string | null;
    refreshTokenExpiresTimestamp: string | null;
    permissions?: PermissionStoreModelEnum[];
    name?: string;
    organisationId?: string;
  }>()
);

export const loadTenantTheme = createAction('[Auth] load tenant theme');
export const loadTenantThemeSuccess = createAction(
  '[Auth] load tenant theme success',
  props<{ lightTheme: ThemeStoreModel; darkTheme: ThemeStoreModel }>()
);
export const loadTenantThemeFailure = createAction('[Auth] load tenant theme failure', props<{ error: string }>());

export const loadTenantSettings = createAction('[Auth] load tenant settings');
export const loadTenantSettingsSuccess = createAction('[Auth] load tenant settings success', props<{ response: TenantSettingsResponse }>());
export const loadTenantSettingsFailure = createAction('[Auth] load tenant settings failure', props<{ error: string }>());

export const loadUserPreferences = createAction('[Auth] load user preferences');
export const loadUserPreferencesSuccess = createAction('[Auth] load user preferences success', props<{ preferences: UserPreferences }>());
export const loadUserPreferencesFailure = createAction('[Auth] load user preferences failure', props<{ error: string }>());

export const saveUserPreferences = createAction('[Auth] save user preferences', props<{ preferences: UserPreferences }>());
export const saveUserPreferencesSuccess = createAction('[Auth] save user preferences success', props<{ preferences: UserPreferences }>());
export const saveUserPreferencesFailure = createAction('[Auth] save user preferences failure', props<{ error: string }>());

export const setThemePreference = createAction('[Auth] set theme preference', props<{ themePreference: ThemePreference }>());
export const setSystemPrefersDark = createAction('[Auth] set system prefers dark', props<{ systemPrefersDark: boolean }>());

export const logout = createAction('[Auth] logout');
